import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Col, Row, Space, Typography } from 'antd';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { DeleteProjectModal } from 'components/molecules/project-actions-modal';
import { useCurrentProject } from 'hooks/use-current-project';
import { useTranslation } from 'hooks/use-translation';
import { SectionTitle } from './styles';

const { Text } = Typography;

const StyledButton = styled(Button)`
  box-shadow: var(--shadow-highlight)
    rgba(var(--red-60-in-rgb), var(--shadow-highlight-color-opacity));
`;

export const DeleteProjectControl: FC = () => {
  const projectDetails = useCurrentProject();

  const deleteTitle = useTranslation('project.delete.cta.title');
  const deleteMessage = useTranslation('project.action.delete.content');
  const deleteButtonText = useTranslation('delete');
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <Row>
      <Col>
        <Space direction="vertical" size="middle">
          <SectionTitle>{deleteTitle}</SectionTitle>
          <Text>{deleteMessage}</Text>
          <StyledButton
            danger
            data-test-id="project.action.delete.btn"
            icon={<TrashCan16 />}
            iconPlacement="right"
            onClick={() => setShowDeleteModal(true)}
          >
            {deleteButtonText}
          </StyledButton>
          <DeleteProjectModal
            isVisible={showDeleteModal}
            projectId={projectDetails.projectId}
            projectName={projectDetails.projectName}
            closeModal={closeDeleteModal}
          />
        </Space>
      </Col>
    </Row>
  );
};
